import { CssProperties, ICssProperty } from "../../../models/css-property";
import { IFormFieldStyleData } from "src/typings/form-widget-style-data";
import { StringUtil } from "../../../utils/string-util";
import { BrowserIdentifierUtil } from "@commonRendering/types";

export class FormFieldStyleRenderer {

    private MAX_BORDER_THICKNESS = 8;

    public getStyles(style?: IFormFieldStyleData): ICssProperty[] {
        const formFiledStyle = new CssProperties();
        const borderWidth = StringUtil.getNumberFromStr(style?.borderWidth ?? "1");

        if (style?.borderRadius) {
            formFiledStyle.tryAdd("--form-field-border-top-left-radius", `${style.borderRadius.topLeftPx}px`);
            formFiledStyle.tryAdd("--form-field-border-top-right-radius", `${style.borderRadius.topRightPx}px`);
            formFiledStyle.tryAdd("--form-field-border-bottom-left-radius", `${style.borderRadius.bottomLeftPx}px`);
            formFiledStyle.tryAdd("--form-field-border-bottom-right-radius", `${style.borderRadius.bottomRightPx}px`);
        }

        formFiledStyle.addObj({
            "--form-field-border-width": style?.borderWidth,
            "--form-field-background-color": style?.bgColor,
            "--form-field-border-color": style?.outlineColor,
            "--form-field-color": style?.textColor,
            "--form-field-padding-left": this.MAX_BORDER_THICKNESS - borderWidth + "px",
            "--form-field-font-family": style?.font?.family ?? "",
            "--form-field-font-weight": style?.font?.weight ?? ""
        });

        const paddingTop = BrowserIdentifierUtil.isSafari() ? this.MAX_BORDER_THICKNESS - borderWidth + 1 + "px" : this.MAX_BORDER_THICKNESS - borderWidth + "px";
        const paddingBottom = BrowserIdentifierUtil.isSafari() ? this.MAX_BORDER_THICKNESS - borderWidth - 1 + "px" : this.MAX_BORDER_THICKNESS - borderWidth + "px";

        formFiledStyle.addObj({
            "--form-field-padding-top": paddingTop,
            "--form-field-padding-bottom": paddingBottom
        });

        formFiledStyle.tryAdd("--form-placeholder-color", style?.textColor);
        formFiledStyle.tryAdd("--form-placeholder-font-family", style?.font?.family ?? "");

        formFiledStyle.tryAdd("--form-description-color", style?.descriptionColor);
        formFiledStyle.tryAdd("--form-field-focus-background-color", style?.focusBackgroundColor);
        formFiledStyle.tryAdd("--form-field-focus-border-color", style?.focusOutlineColor);

        return formFiledStyle.data;
    }

}
